import api from "./api";
export type DeleteWarehouseDto = {
  id: number | string;
};

/*Search & Filter */

export const getBillsReturns = async (body: {
  limit: number;
  q: string;
}) => {
  let url = `/bills-returns?limit=${body.limit}&q=${body.q.toString()}`;
  return await api.get(url);
};
